//创建动态路由

// import pcLayoutViewMixins from "../mixins/pcLayoutView";
// import mobileLayoutViewMixins from "../mixins/mobileLayoutView";
// import enums from "../../cli-core/utils/enums";
const enums = dsf.enums;
const preView = "preView";
let __componetMap = {
  pc: {},
  mobile: {}
};
const NOT_FOUND_EXTJS = "EXTJS未能找到或内部代码错误";

function setMap(client, name, options, hasExtJs) {
  if (!hasExtJs) {
    name = preView + "_" + name;
  }
  __componetMap[client][name] = options;
}

function getMap(client, name, hasExtJs) {
  if (!hasExtJs) {
    name = preView + "_" + name;
  }
  return __componetMap[client][name];
}

function getComponentName(client, ns) {
  return client + "-" + ns.replace(/\./g, "-");
}
function getModuleName(client, ns) {
  let info = splitNameSpace(ns);
  let serverCreateHtmlDir = dsf.config.serverCreateHtmlDir;
  return client + "/views/" + info.ns + "/" + info.file + ".ext";
}
//切割nameSpace
function splitNameSpace(nameSpace) {
  if (nameSpace.startsWith(".")) {
    nameSpace = nameSpace.substr(1);
  }
  let arr = nameSpace.split(".");
  let fileName = arr[arr.length - 1];
  let path = arr.slice(0, arr.length).join(".");
  let ns = arr.slice(0, arr.length - 1).join(".");
  return {
    path: path,
    file: fileName,
    ns: ns
  };
}
//动态创建组件
function getRemoteComponent(ns, client, cache, hasExtJs = true) {
  return new Promise((resolve, reject) => {
    //加载组件的js、css文件
    // let _this = this;
    if (!getMap(client, ns, hasExtJs)) {
      getComponentTemplate(ns, client, cache, hasExtJs)
        .then((response) => {
          if (!getMap(client, ns, hasExtJs)) {
            let moduleName = getModuleName(client, ns);
            dsf.performance.start("解析" + moduleName + "布局");
            let templateStr = response.context.tpl;
            let compileFn = null;
            //如果程序已经执行过预编译则直接使用render函数
            if (response.context.render) {
              let render = response.context.render;
              let staticRenderFns = response.context.staticRenderFns || undefined;
              if (client == "mobile") {
                let layoutViewRender = render;
                render = function (h) {
                  var _vm = this;
                  let viewVnodes = layoutViewRender.call(_vm);
                  let vnode = h("div", {}, dsf.isArray(viewVnodes) ? viewVnodes : [viewVnodes]);
                  return vnode;
                };
              }
              compileFn = {
                render,
                staticRenderFns
              };
            } else {
              if (client == "mobile") {
                templateStr = `<div>${templateStr}</div>`;
              }
              compileFn = Vue.compile(templateStr);
            }
            let serverCreateHtmlDir = dsf.config.serverCreateHtmlDir;
            cache = isUseCache(cache);
            dsf.performance.end("解析" + moduleName + "布局");
            dsf.performance.start("加载" + moduleName);
            //组件渲染的render函数
            let componentRender = {
              staticRenderFns: compileFn.staticRenderFns,
              render: function (h) {
                if (this?.$noAccess) {
                  return (
                    <div class="ds-error-wrap">
                      <div class="redict-content">
                        <img src="/static/img/platform/error-403.png" class="error-img" />
                        <p class="sub-title sub-title1">抱歉！您没有访问权限，请联系管理员</p>
                      </div>
                    </div>
                  );
                }
                return compileFn.render.call(this, h);
              }
            };
            if (hasExtJs) {
              dsf.require(
                {
                  baseUrl: serverCreateHtmlDir,
                  urlArgs: cache ? null : "_t=" + dsf.cacheTime
                },
                [moduleName],
                (ext) => {
                  let showLogicCompile = response?.context?.layout?.showLogicCompile || {};
                  initExtJs(ext, ns, client, response);
                  extAttachVueMember(ext, componentRender, true, showLogicCompile);
                  setMap(client, ns, ext, true);
                  dsf.global.Vue.component(ext.name, ext);
                  dsf.performance.end("加载" + moduleName);
                  // dsf.debugTimeEnd("加载" + moduleName)
                  resolve(ext);
                  response = null;
                },
                (err) => {
                  err && dsf.error(err);
                  let msg = { message: NOT_FOUND_EXTJS };
                  dsf.layer.message(msg, false);
                  reject(msg);
                }
              );
            } else {
              let ext = {};
              let showLogicCompile = response?.context?.layout?.showLogicCompile || {};
              initExtJs(ext, ns, client, response);
              extAttachVueMember(ext, componentRender, false, showLogicCompile);
              let name = "preView" + ext.name;
              ext.name = name;
              setMap(client, ns, ext, false);
              dsf.global.Vue.component(name, ext);
              resolve(ext);
              response = null;
            }
          } else {
            resolve(getMap(client, ns, hasExtJs));
          }
        })
        .catch((ex) => {
          reject(ex);
        });
    } else {
      resolve(getMap(client, ns, hasExtJs));
    }
  });
}

function initExtJs(ext, ns, client, response) {
  ext.mode = response?.context?.layout?.mode || enums.viewMode.DEVELOP;
  ext.pageType = response?.context?.layout?.pageType;
  ext.pageTitle = response.context.layout.title;
  ext.name = _.camelCase(getComponentName(client, ns));
  ext.needLogin = response.context.layout.needLogin !== false;
  ext.pageLevel = response.context.layout.pageLevel || 1;
  ext.isKeepAlive = response.context.layout.isKeepAlive || false;
  let mixin = client == "mobile" ? $mixins.mobileLayoutView : $mixins.pcLayoutView;
  ext.extends = mixin;
  ext.mixins = [];
  ext.isEs = response?.context?.layout?.isEs || false;
  ext.esIndexName = response?.context?.layout?.esIndexName || false;
  ext.waterMark = response.context.layout.waterMark !== false;
  ext.metadataDict = () => JSON.parse(response?.context?.metadataDict);
  ext.layoutComponentProps = response?.context?.componentProps;
  ext.$$service = dsf.mix(true, {}, response?.context?.service || {});
  ext.$$pageDesignId = response?.context?.layout?.designId || "";
  let pt = dsf.config.layoutViewMixins[response.context.layout.pageType];
  ext.staticData =
    ext.mode === enums.viewMode.PROTOTYPE
      ? () => JSON.parse(response?.context?.staticValue)
      : () => null;
  // ext.staticData = () => {
  //   if (ext.mode === enums.viewMode.PROTOTYPE) {
  //     return JSON.parse(response?.context?.staticValue);
  //   } else {
  //     return null;
  //   }
  // };
  // if (ext.mode === enums.viewMode.PROTOTYPE) {
  //   ext.staticData = () => JSON.parse(response?.context?.staticValue);
  // } else {
  //   ext.staticData = () => null;
  // }
  //如果是其他特殊类型表单，例如问卷
  _.each(pt || [], (it) => {
    //读取页面是否有其他混入配置
    if (window.$mixins[it]) {
      ext.mixins.push(window.$mixins[it]);
    }
  });
}

function extAttachVueMember(ext, options, hasExtJs, showLogicCompile) {
  let vueOptions = {
    beforeCreate() {
      this.$$getLayoutComponentsProps = function () {
        return JSON.parse(ext.layoutComponentProps);
      };
    },
    data() {
      // let staticData = staticData;
      let controls = this.$$getLayoutComponentsProps();
      let exculds = [
        "isDsf",
        "hidePostNullValue",
        "hideIgnoreValidate",
        "isPostNull",
        "isMergeHttp",
        "development",
        "designerInfo",
        "metadataAttach",
        "designLock",
        "desCopyedChangeCaption",
        "metaDataLevel",
        "designProxy",
        "designOnlySlot",
        "designInductionSlot",
        "designShowMark",
        "designShowMarkCaption",
        "designShowMarkInfo",
        "designShowMarkRemove",
        "designShowMarkDragDrop",
        "designDisabledProps"
      ];
      let ctrlTreeInfo = {};
      _.each(controls, (it, k) => {
        _.each(exculds, (prop) => {
          delete it[prop];
        });
        updateControlChildrenHand(it, controls, ctrlTreeInfo);
      });
      // ctrlTreeInfo记录者控件的父子关系
      // 通过ctrlTreeInfo能判断出一个控件内有多少子控件
      this.ctrlTreeInfo = Object.freeze(ctrlTreeInfo);
      this.showLogicCompile = Object.freeze(showLogicCompile);
      return {
        $$esIndexName: ext.esIndexName,
        $$isEs: ext?.isEs,
        $$staticValue: ext.staticData(),
        $$service: ext.$$service,
        $$controls: controls,
        $$keepAlive: ext?.isKeepAlive,
        $$pageType: ext?.pageType,
        $$mode: ext?.mode,
        $$pageDesignId: ext.$$pageDesignId || "",
        metadataDict: ext.metadataDict() //dsf.mix(true, {}, ext.metadataDict)
      };
    },
    computed: {
      $isEs() {
        return this._data.$$isEs;
      },
      $esIndexName() {
        return this._data.$$esIndexName;
      },
      $controls() {
        return this._data.$$controls;
      },
      $controlsMapping() {
        let mapping = {};
        for (let k in this._data.$$controls) {
          let props = this._data.$$controls[k];
          let hash = k.split("-")[1];
          hash = hash ? "-" + hash : "";
          let key = props.caption + hash;
          if (props.isFormControl) {
            key = props.metadata_fullcode + hash;
          }
          mapping[key] = k;
        }
        return mapping;
      },
      $service() {
        return this?._data?.$$service;
      },
      $baseUrl: {
        get() {
          return this?.$service?.baseUrl || "";
        },
        set(v) {
          this.$set(this.$service, "baseUrl", v);
        }
      },
      $pageComponentProps() {
        return this._data.$$controls[this._data.$$pageDesignId];
      }
    },
    created() {},
    destroyed() {
      for (let k in this._data.$$controls) {
        this._data.$$controls[k] = null;
        delete this._data.$$controls[k];
      }
      this.$$getLayoutComponentsProps = null;
    }
  };
  let op = dsf.mix(vueOptions, options);
  if (!hasExtJs) {
    ext.mixins.push({
      provide() {
        return {
          $isPreView: true
        };
      }
    });
  }
  ext.mixins.push(op);
}

//更新组件中slot指向的数据
function updateControlChildrenHand(ctrl, controls, ctrlTreeInfo, parent = null) {
  let obj = {};
  _.each(ctrl?.slots || [], (slot) => {
    let children = _.map(slot.controls, (c) => {
      obj[c.designId] = ctrlTreeInfo[c.designId] || {};
      if (controls[c.designId]) {
        return controls[c.designId];
      } else {
        updateControlChildrenHand(c, controls, ctrlTreeInfo, ctrl);
        return c;
      }
    });
    slot.controls = children;
  });
  if (!ctrlTreeInfo[ctrl.designId]) {
    ctrlTreeInfo[ctrl.designId] = obj;
  } else {
    Object.assign(ctrlTreeInfo[ctrl.designId], obj);
  }
}

function isUseCache(cache) {
  if (dsf.isUnDef(cache)) {
    cache = dsf.config.setting_public_layoutviewcache;
  }
  return cache;
}

function preLoadExtJs(ns, client, cache) {
  let jsPath = getModuleName(client, ns);
  let id = jsPath.replace(/\.|\//g, "");
  if (!document.querySelector("#" + id)) {
    cache = isUseCache(cache);
    let serverCreateHtmlDir = dsf.config.serverCreateHtmlDir;
    let url = serverCreateHtmlDir + jsPath + ".js" + (cache ? "" : "?_t=" + dsf.cacheTime);
    dsf.preloadScript(url, id);
  }
}
//获取
function getComponentTemplate(ns, client, cache, hasExtJs) {
  if (hasExtJs) {
    preLoadExtJs(ns, client, cache);
  }
  return new Promise((resolve, reject) => {
    let response = null;
    let layoutAndStyle = null;
    getLayout(ns, client, cache)
      .then((res) => {
        //加载异步组件
        response = res;
        layoutAndStyle = getLayoutAndStyleData(response ? response.data : {});
        let callback = function (com) {
          //如果组件为表单组件且为文本代理状态，则不当异步组件处理
          return !(com.isFormControl && com.textProxy);
        };
        return dsf.designer.requestAsyncComponentsByLayout(layoutAndStyle.layout, callback);
      })
      .then(() => {
        try {
          let props = dsf.fillComponentDefaultProps(layoutAndStyle.layout);
          let css = layoutAndStyle.css;
          props["module-name"] = ns;
          let styleEl = `<style>${css}</style>`;
          props["customCss"] = styleEl;
          dsf.setObjAttr(props, "showLogicCompile", layoutAndStyle.showLogicCompile);
          // debugger
          let tplAndProps = null;
          //如果表单不带有render或者没有extJs则生成字符串模板
          if (!layoutAndStyle.render || !hasExtJs) {
            tplAndProps = dsf.designer.convertTemplateAndControlData(props, false, false, hasExtJs);
          } else {
            tplAndProps = dsf.designer.convertControlData(props);
          }
          let asyncComList = [];
          let result = {
            context: {
              tpl: tplAndProps.tpl || "",
              componentProps: JSON.stringify(tplAndProps.props), //JSON.parse(JSON.stringify(tplAndProps.props)),
              layout: props,
              moduleName: ns,
              metadataDict: layoutAndStyle.metadataDict || {},
              service: layoutAndStyle.service || {},
              staticValue: layoutAndStyle.staticValue || {},
              render: layoutAndStyle.render,
              staticRenderFns: layoutAndStyle.staticRenderFns,
              showLogicCompile: layoutAndStyle.showLogicCompile
            }
          };
          resolve(result);
        } catch (ex) {
          throw ex;
        }
      })
      .catch((ex) => {
        if (dsf.type(ex) == "error") {
          let r_notfound = /40[34]+|50.+/g;
          if (r_notfound.test(ex.message)) {
            reject();
          } else {
            dsf.error(ex);
          }
        } else {
          reject(ex);
        }
      })
      .finally(() => {
        response = null;
        layoutAndStyle = null;
      });
  });
}

//获取页面布局tree结构数据
function getLayout(ns, client, cache) {
  let viewinfo = splitNameSpace(ns);
  let serverCreateHtmlDir = dsf.config.serverCreateHtmlDir;
  // dsf.debugTime("加载" + viewinfo.file)
  let url = client + "/views/" + viewinfo.ns + "/" + viewinfo.file + ".layout.html";
  cache = isUseCache(cache);
  let p = dsf.http
    .get(
      url,
      null,
      {
        cache,
        responseType: "text"
      },
      serverCreateHtmlDir
    )
    .then((res) => {
      // dsf.debugTimeEnd("加载" + viewinfo.file)
      return res;
    });
  return p;
}

//获取布局数据
function getLayoutAndStyleData(context) {
  let dom = document.createDocumentFragment();
  let div = document.createElement("div");
  div.innerHTML = context;
  dom.appendChild(div);
  //布局内容
  const layoutNode = div.querySelector("#layout");
  //css内容
  const cssNode = div.querySelector("#css");
  //显示逻辑配置
  const showLogicNode = div.querySelector("#showLogicCompile");
  //元数据内容
  const metadataNode = div.querySelector("#metadatedict");
  const metadataNodeContent = metadataNode ? metadataNode.innerHTML.trim() : "";
  //微服务内容
  const serviceNode = div.querySelector("#service");
  //静态数据内容
  const staticValueNode = div.querySelector("#staticValue");
  const staticRenderFnsNode = div.querySelector("#staticRenderFns");
  const renderNode = div.querySelector("#render");
  //编译后的页面函数
  let staticRenderFnsCode = [
    "var staticRenderFns=" +
      (staticRenderFnsNode ? staticRenderFnsNode.innerHTML.trim() : "null").trim() +
      ";",
    "return staticRenderFns;"
  ];
  let renderCode = renderNode ? renderNode.innerHTML.trim() : "";
  let layoutFn = function () {
    var layout = JSON.parse(layoutNode ? layoutNode.innerHTML : "");
    return layout;
  };
  let cssFn = function () {
    var css = (cssNode ? cssNode.innerHTML : "").trim();
    return css;
  };
  let showLogicFn = function () {
    let str = showLogicNode ? showLogicNode.innerHTML.trim() : null;
    if (!str) return {};
    return new Function(str + "\nreturn fnMap;")();
  };
  let layout = dsf.fillComponentDefaultProps(layoutFn());

  let css = cssFn();
  let showLogicCompile = showLogicFn();
  let metadataDict = (metadataNodeContent ? metadataNodeContent : "{}").trim();
  let serviceFn = function () {
    let service = new Function(
      ["var s=", (serviceNode ? serviceNode.innerHTML : "{}").trim(), "return s"].join("\r\n")
    );
    return service();
  };
  let service = serviceFn();
  let staticValue = (staticValueNode ? staticValueNode.innerHTML : "{}").trim();
  let renderFn = null;
  let render, staticRenderFns;
  if (renderCode) {
    renderFn = new Function([renderCode].join("\n"));
    let staticRenderFnsFn = new Function(staticRenderFnsCode.join("\n"));
    render = renderFn;
    staticRenderFns = staticRenderFnsFn();
    if (staticRenderFns) {
      let arr = [];
      let fns = ["var fns=[];"];
      _.each(staticRenderFns, (fnStr, i) => {
        let fn = "var fn_" + i + "=function(){";
        fn += fnStr;
        fn += "};";
        fn += "fns.push(fn_" + i + ")";
        fns.push(fn);
      });
      fns.push("return fns;");
      try {
        let sfn = new Function(fns.join("\r\n"));
        staticRenderFns = sfn();
      } catch (ex) {
        dsf.error(ex);
      }
    }
  }
  layoutFn = null;
  cssFn = null;
  serviceFn = null;
  renderCode = null;
  staticRenderFnsCode.splice(0, staticRenderFnsCode.length);
  for (let i = div.childNodes.length - 1; i >= 0; i--) {
    div.removeChild(div.childNodes[i]);
  }
  for (let i = dom.childNodes.length - 1; i >= 0; i--) {
    dom.removeChild(dom.childNodes[i]);
  }
  div = null;
  dom = null;
  return {
    layout,
    css,
    showLogicCompile,
    metadataDict,
    service,
    staticValue,
    staticRenderFns,
    render
  };
}

const dynamicComponent = function (namespace, client, cache, hasExtJs = true) {
  // let cname = getComponentName(namespace);
  client = client || "pc";
  return getRemoteComponent(namespace, client, cache, hasExtJs);
};
dynamicComponent.remove = function (client, ns) {
  let name = getComponentName(client, ns);
  name = _.camelCase(name);
  //移除全局注册的组件
  delete Vue.options.components[name];
  delete __componetMap[client][ns];
  //清理掉动态加载的组件二开js
  let mname = getModuleName(client, ns);
  dsf.require.undef(mname);
};
export default dynamicComponent;
